import React, { useState } from 'react';

import Rating from '../Rating';
import ThankYou from '../ThankYou';

const Card: React.FC = () => {
	const [submitted, setSubmitted] = useState<boolean>();
	const [currentRating, setCurrentRating] = useState<number>(5);

	const updateRatingHandler = (num: number) => {
		setCurrentRating(num);
	};

	const submitHandler = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		event.preventDefault();

		setSubmitted(true);
	};

	return (
		<div className='bg-custom-gradient h-fit max-w-xs rounded-2xl mt-4 mx-auto mb-0 p-6 md:max-w-md md:p-8 md:h-[416px]'>
			{submitted ? (
				<ThankYou currentRating={currentRating} />
			) : (
				<Rating onRatingClick={updateRatingHandler} onSubmitClick={submitHandler} />
			)}
		</div>
	);
};

export default Card;
